import { Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-error-email',
  templateUrl: './error-email.html',
  styleUrl: './error-email.scss',
})
export class ErrorEmailComponent {
  errorMsg = 'Email adresa mora biti postojeća';

  formCtrl = input.required<FormControl<any>>();
}
